module.exports = __webpack_public_path__ + "static/media/substance-abuse-active.2909ef11.svg";